<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import i18n from "../../../../i18n";
import { servicehelpers } from "../../../../services/servicehelpers";
import { commissiontypeService } from "../../../../services/saleservice/commissiontype.service";
// import { settingService } from "../../../../services/settingservice/setting.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Loan Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "loan template",
      breadCrumb: {},

      interestWidth: 'col-md-12',
      payShow: false,
      durationShow: false,

      commissiontype: {},
      paymentTypeDataList: {},
      commissionTypeForDataList: {},

      valueName: '',
      valueCommissionTypeFor: 0,
      valueSeller: 0,
      valueSellerType: 0,
      valueAgency: 0,
      valueAgencyType: 0,

    };
  },

  // watch: {
  //     valueFor: function(newVal) { 

  //       if(this.commissionTypeForDataList.data) {
  //         this.loanCommissionTypeForChanged(newVal);
  //       }
  //     }
  // },

  mounted() {

    this.loadingPaymentTypeData();
    this.loadingCommissionTypeForData();

    // this.valueCommissionTypeFor = 1;
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      commissiontypeService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.commissiontype = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };

          // console.log(JSON.stringify(this.commissiontype));

          this.valueName = this.commissiontype.name;
          this.valueCommissionTypeFor = this.commissiontype.commission_for;
          this.valueSeller = this.commissiontype.seller_amount;
          this.valueSellerType = this.commissiontype.seller_type;
          this.valueAgency = this.commissiontype.agency_amount;
          this.valueAgencyType = this.commissiontype.agency_type;


        });
    },

    loadingPaymentTypeData: function() {
      servicehelpers.getPayementTypeData()
        .then(response => {
          this.paymentTypeDataList = response;
        });
    },

    loadingCommissionTypeForData: function() {

      servicehelpers.getCommissionTypeForData().then(response => {
        this.commissionTypeForDataList = response;

      });
    },

    clearForm: function() {
      this.valueName = '';
      this.valueFor = 0;
      this.valueSeller = 0;
      this.valueSellerType = 0;
      this.valueAgency = 0;
      this.valueAgencyType = 0;
    },


    submitSave: function() {
      
      this.tryingToSubmit = true;

      let commission = {
        name: this.valueName,
        commission_for: this.valueCommissionTypeFor,
        seller_amount: this.valueSeller,
        seller_type: this.valueSellerType,
        agency_amount: this.valueAgency,
        agency_type: this.valueAgencyType
      };

      // console.log(JSON.stringify(loanTemplate))

      if(this.isAdd) {
        commissiontypeService.insert(commission).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-commission"
                });
              } 
            });

          }
        });
      } else {
        // console.log(JSON.stringify(commission));

        commissiontypeService.update(this.$route.params.id, commission).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-commission"
                });
              } 
            });

          }
        });
      }

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.configuration.commission-rule.text'),
        href: '/setting/commission',
      }, {
        text: $t('setting.configuration.commission-rule.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.configuration.commission-rule.new') : $t('setting.configuration.commission-rule.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.configuration.commission-rule.text'),
        href: '/setting/commission',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.configuration.commission-rule.new') : $t('setting.configuration.commission-rule.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />


    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :label="'setting.configuration.commission-rule.name'"  />
              </div>
              <div class="col-md-6">

                 <Select 
                    :id="'commission_for'"
                    :text="'name'"
                    :text2="'name_en'"
                    v-model="valueCommissionTypeFor"
                    :list="this.commissionTypeForDataList"
                    :label="'setting.configuration.commission-rule.for'"  />
              </div>
            </div>
            <div v-show="valueCommissionTypeFor == 1 || valueCommissionTypeFor == 3" class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'seller_amount'"
                    v-model="valueSeller"
                    :label="'setting.configuration.commission-rule.for-seller'"  />
              </div>
              <div class="col-md-6">
                 <Select 
                    :id="'agency_type'"
                    :text="'name'"
                    :required="true"
                    v-model="valueSellerType"
                    :list="this.paymentTypeDataList"
                    :label="'setting.configuration.commission-rule.seller-type'"  />
              </div>
            </div>
            <div v-show="valueCommissionTypeFor == 2 || valueCommissionTypeFor == 3" class="row">
              <div class="col-md-6">
                 <Input 
                    :type="'number'"
                    :id="'agency_amount'"
                    v-model="valueAgency"
                    :label="'setting.configuration.commission-rule.for-agency'"  />
              </div>
              <div class="col-md-6">
                 <Select 
                    :id="'agency_type'"
                    :text="'name'"
                    :required="true"
                    v-model="valueAgencyType"
                    :list="this.paymentTypeDataList"
                    :label="'setting.configuration.commission-rule.agency-type'"  />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
              </div>
              <div class="col-md-6">
                 <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
              </div>
            </div>

          </div>
        </div>

      </div>
    </b-form> 

  </Layout>
</template>